import { ListOption } from '../models';

export const ADDONS: readonly ListOption[] = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.HAND_OVER_PERSONALLY',
    value: 'hand_over_personally',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.DOCS_RETURN',
    value: 'documents_return',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.SUBPOENA',
    value: 'subpoena',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.CAREFUL_FRAGILE',
    value: 'careful_fragile',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.OPEN_UPON_DELIVERY',
    value: 'open_upon_delivery',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.BULKY',
    value: 'bulky',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.SERVICE',
    value: 'service',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.GOV_LETTER',
    value: 'government',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.MILITARY',
    value: 'military',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.DESCRIPTION',
    value: 'description',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.RECIPIENT_PAYMENT',
    value: 'recipient_payment',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.PARTIAL_RETURN',
    value: 'partial_return',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.DELIVER_TO_WORK',
    value: 'deliver_to_work',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.COORDINATE_DELIVERY_INTERVAL',
    value: 'coordinate_delivery_interval',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.EMS.TITLE',
    value: 'time_of_delivery',
  },
];
export const ADDONS_MAP = new Map<string, string>(
  ADDONS.map((item) => [item.value, item.label]) as any
);
